import { Youtube, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
import { XIcon } from '../icons/XIcon';

const TikTokIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"></path></svg>
)

const socialLinks = [
  { href: "https://www.youtube.com/@jartiland", icon: <Youtube className="h-6 w-6"/>, name: "YouTube" },
  { href: "https://www.instagram.com/jartiland/", icon: <Instagram className="h-6 w-6"/>, name: "Instagram" },
  { href: "https://www.tiktok.com/@jartiland_minecraft?lang=es", icon: <TikTokIcon />, name: "TikTok" },
  { href: "https://x.com/jartiland", icon: <XIcon className="h-5 w-5"/>, name: "X" },
]

export function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/8 bg-background py-16">
      <div className="absolute left-1/2 top-0 h-px w-2/3 -translate-x-1/2 bg-gradient-to-r from-transparent via-primary/40 to-transparent" />
      <div className="absolute -bottom-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-primary/5 blur-[100px]" />

      <div className="container relative mx-auto flex flex-col items-center justify-center gap-8 px-4 text-center">
        <div className="flex flex-col items-center gap-5">
          <h3 className="text-xs font-bold uppercase tracking-[0.35em] text-primary">Síguenos en redes</h3>
          <div className="flex items-center gap-3">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/8 bg-card/40 text-muted-foreground backdrop-blur-sm transition-all hover:-translate-y-0.5 hover:border-primary/40 hover:text-primary"
              >
                {social.icon}
                <span className="sr-only">{social.name}</span>
              </a>
            ))}
          </div>
        </div>

        <div className="h-px w-full max-w-xs bg-white/8" />

        <div className="flex flex-wrap justify-center gap-4 text-sm text-muted-foreground">
          <Link to="/legal/aviso-legal" className="transition-colors hover:text-primary">Aviso Legal</Link>
          <span className="opacity-30">|</span>
          <Link to="/legal/politica-de-privacidad" className="transition-colors hover:text-primary">Política de Privacidad</Link>
          <span className="opacity-30">|</span>
          <Link to="/legal/politica-de-cookies" className="transition-colors hover:text-primary">Política de Cookies</Link>
        </div>

        <p className="text-center text-sm text-muted-foreground">
          © {new Date().getFullYear()} Jartiland. Todos los derechos reservados.
        </p>

        <p className="text-xs text-muted-foreground">
          Web desarrollada por{" "}
          <a
            href="https://www.instagram.com/daviidfouces"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-foreground transition-colors hover:text-primary"
          >
            David Fouces
          </a>
        </p>
      </div>
    </footer>
  );
}
